import LandingPage from "../components/homePage/LandingPage"

export default function Home(){
    return(
        <LandingPage/>
    )
}